/**
 * @generated SignedSource<<2533fc56f3c07a1662587e495c5ad70c>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
export type JiraAppType = "CONNECT" | "FORGE" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type Nav4Apps_GlobalAppsFragment$data = {
  readonly globalAppNavigationItems?: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly appType?: JiraAppType | null;
        readonly sections?: ReadonlyArray<{
          readonly links: ReadonlyArray<{
            readonly url: string | null;
          } | null> | null;
        } | null> | null;
        readonly url?: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly " $fragmentType": "Nav4Apps_GlobalAppsFragment";
};
export type Nav4Apps_GlobalAppsFragment$key = {
  readonly " $data"?: Nav4Apps_GlobalAppsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"Nav4Apps_GlobalAppsFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "url"
};
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "cloudId"
    },
    {
      "kind": "RootArgument",
      "name": "isAppsExpanded"
    }
  ],
  "kind": "Fragment",
  "name": "Nav4Apps_GlobalAppsFragment",
  "selections": [
    {
      "condition": "isAppsExpanded",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": [
            {
              "kind": "Variable",
              "name": "cloudId",
              "variableName": "cloudId"
            }
          ],
          "concreteType": "JiraNavigationItemConnection",
          "kind": "LinkedField",
          "name": "globalAppNavigationItems",
          "plural": false,
          "selections": [
            {
              "concreteType": "JiraNavigationItemEdge",
              "kind": "LinkedField",
              "name": "edges",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "node",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "ScalarField",
                          "name": "appType"
                        },
                        (v0/*: any*/),
                        {
                          "concreteType": "JiraAppSection",
                          "kind": "LinkedField",
                          "name": "sections",
                          "plural": true,
                          "selections": [
                            {
                              "concreteType": "JiraAppNavigationItemNestedLink",
                              "kind": "LinkedField",
                              "name": "links",
                              "plural": true,
                              "selections": [
                                (v0/*: any*/)
                              ]
                            }
                          ]
                        }
                      ],
                      "type": "JiraAppNavigationItem"
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "JiraQuery"
};
})();

(node as any).hash = "fcee4331eb5ce6a0f2c7ee593634458d";

export default node;
